(() => {
  document.addEventListener('click', (event) => {
    const link = event.target && event.target.closest ? event.target.closest('[data-salty-direct-cart-link]') : null;
    if (!link) return;

    // Keep the header cart icon as a plain, browser-friendly link to Shopify's normal /cart page.
    // Do not redirect customers to /checkout or generated /checkouts/... URLs from the header.
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(link.href);
  }, true);
})();
